// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__13rMh","label":"Category_label__3p-zC","content":"Category_content__1W0HK","header":"Category_header__2TfY1","location":"Category_location__3Zjj3"};